import { render } from "./NfcScanView.vue?vue&type=template&id=4bfdc799"
import script from "./NfcScanView.vue?vue&type=script&lang=js"
export * from "./NfcScanView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__